import React from 'react';
import { TouchableOpacity, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import theme from '../../config/theme';

interface ChecklistField {
  id: string;
  nome: string;
  // Outras propriedades não são necessárias aqui
}

interface ChecklistReadyMessageFieldProps {
  field: ChecklistField;
  value?: string;
  onChange: (val: string) => void;
}

/**
 * Campo "mensagem pronta" para checklists.
 * Exibe um checkbox ao lado do nome do campo. Quando marcado, o valor armazenado
 * é justamente o nome do campo; quando desmarcado, o valor é string vazia.
 */
const ChecklistReadyMessageField: React.FC<ChecklistReadyMessageFieldProps> = ({
  field,
  value,
  onChange,
}) => {
  const checked = value === field.nome;

  const toggle = () => {
    if (checked) {
      onChange('');
    } else {
      onChange(field.nome);
    }
  };

  return (
    <TouchableOpacity
      style={[styles.container, checked && styles.checked]}
      onPress={toggle}
      accessibilityRole="checkbox"
      accessibilityState={{ checked }}
    >
      <Ionicons
        name={checked ? 'checkbox' : 'square-outline'}
        size={20}
        color={checked ? theme.colors.primary.default : theme.colors.text.secondary}
      />
      <Text style={styles.label}>{field.nome}</Text>
    </TouchableOpacity>
  );
};

export default ChecklistReadyMessageField;

// Estilos minimalistas seguindo padrão do app
const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 48,
    padding: theme.components.checklistEditor.spacing.cardPadding,
    borderWidth: 1,
    borderColor: theme.colors.border.light,
    borderRadius: 9,
    backgroundColor: theme.colors.background.secondary,
  },
  checked: { borderColor: theme.colors.primary.light },
  label: {
    flex: 1,
    marginLeft: theme.spacing.sm,
    fontSize: theme.fontSizes.sm,
    color: theme.colors.text.primary,
  },
}); 